var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title-description-universal"},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"title-description-universal__title h4-title",domProps:{"innerHTML":_vm._s(_vm.text.mainTitle)}})
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"title-description-universal__description body1",domProps:{"innerHTML":_vm._s(_vm.text.mainDescription)}})
}]

export { render, staticRenderFns }